import React, { useState, useEffect } from "react";
import Sidebar from "../src/Components/Sidebar";
import Layout from "./layout/Layout";
import "./index.css";
import ServiceTable from "./Components/AdminServiceComponent/ServiceTable";
import ServiceForm from "./Components/AdminServiceComponent/ServiceForm";
import { useQuery, gql } from "@apollo/client";
import Loader from "./Loader";
const SERVICES_LIST = gql`
  query {
    getAdminService {
      services {
        metaData
        displayOrder
        cutPrice
        quickPrice
        freeService
        shortDescription
        recommendations
        specialPrice
        campaignPrice
        campaignStartAt
        campaignEndAt
        campaignLabel
        isCampaignActive
        isPackage
        allowTimeBypass
        requiresTimerVerification
        selectionCount
        inventoryGenerationMode
        packageChildServices {
          id
          name
        }
        id
        name
        price
        description
        time
        isFeatured
        isActive
        imageURL
        gender
        details
        productsUsed {
          name
          imageUrl
        }
        product {
          id
          name
        }
        serviceCategory {
          id
          name
        }
        serviceChild {
          id
          price
          alternateGroupId
          serviceInventory {
            id
            name
            parts
            minStock
            canDecrease
            abbr
          }
        }
      }
    }
  }
`;
const AdminService = () => {
  const { loading, error, data } = useQuery(SERVICES_LIST);
  const [dataList, setData] = useState([]);
  const [openServiceForm, setOpenServiceForm] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  useEffect(() => {
    try {
      setServiceList(data.getAdminService.services);
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, [data]);
  if (loading || !isFetched) return <Loader />;
  return (
    <>
      {isFetched ? (
        <div className="min-h-screen flex">
          <Sidebar />
          <Layout>
            {openServiceForm ? (
              <ServiceForm
                setOpenServiceForm={setOpenServiceForm}
                duplicateFormData={duplicateData}
              />
            ) : (
              <ServiceTable
                data={dataList}
                serviceList={serviceList}
                setOpenServiceForm={setOpenServiceForm}
                setDuplicateData={setDuplicateData}
              />
            )}
          </Layout>
        </div>
      ) : (
        <div className="min-h-screen flex">
          <Sidebar />
        </div>
      )}
    </>
  );
};

export default AdminService;
